import React from "react";
import { SelectPicker } from "rsuite";

export interface SelectOption {
  label: string;
  value: string | number;
}

interface Props {
  options: SelectOption[];
  value: string | number | null;
  onChange: (value: string | number | null) => void;
  placeholder?: string;
  disabled?: boolean;
  cleanable?: boolean;
  className?: string;
}

/**
 * Select com BUSCA (digite para filtrar). Wrapper do rsuite SelectPicker padronizado para o NINA.
 * Single-select. Para multiseleção use MultiSelect.
 */
const SearchableSelect: React.FC<Props> = ({
  options,
  value,
  onChange,
  placeholder = "Selecione…",
  disabled = false,
  cleanable = true,
  className,
}) => (
  <SelectPicker
    data={options}
    value={value as any}
    onChange={(v) => onChange((v as string | number | null) ?? null)}
    placeholder={placeholder}
    disabled={disabled}
    cleanable={cleanable}
    searchable
    block
    menuMaxHeight={280}
    className={className}
  />
);

export default SearchableSelect;
